import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, Category, Type, NodeModel } from '@xanadu/model';
import { TypeCache } from '@xanadu/cache';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CategoryCache } from '../../cache/category.cache';

@Component({
    selector: 'app-type-view',
    templateUrl: './type-view.component.html',
    styleUrls: ['./type-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('type-view')
export class TypeViewComponent extends NodeViewComponent<Type | Category> {
    private readonly typeCache = inject(TypeCache);
    private readonly categoryCache = inject(CategoryCache);

    protected get nodeType(): string | undefined {
        return 'type';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;

        if (node instanceof Category) {
            return {
                node: node,
                component: 'category-panel'
            };
        } else {
            return {
                node: node,
                component: 'type-panel'
            };
        }
    }

    protected delete(node: Node): Observable<Type | Category> {
        return this.dataService.delete<Type | Category>(node as any)
            .pipe(switchMap(node => {
                if (node instanceof Type) {
                    this.typeCache.update();
                } else if (node instanceof Category) {
                    this.categoryCache.update();
                }

                return of(node);
            }));
    }
}
